<template>
  <div class="lose-reason-table">
    <el-table
      :data="loseReasons"
      stripe
      @header-click="headerClick"
      style="width: 100%"
      empty-text="データがありません。"
    >
      <el-table-column label="落選理由" :render-header="renderHeader" min-width="40%">
        <template slot-scope="scope">{{ reasonName(scope.row.name) }}</template>
      </el-table-column>
      <el-table-column label="件数" sort-by="count" :render-header="renderHeader" min-width="60%">
        <template slot-scope="scope">
          <div>{{ scope.row.count }}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent, PropType } from 'vue'

import { INSTANTWIN_LOSE_REASON } from '@/client/constant'
import Util from '@/client/core/util'

export default defineComponent({
  props: {
    loseReasons: Array as PropType<readonly unknown[]>,
    sortBy: String
  },
  methods: {
    /**
     * 落選理由名称の取得
     * @param {string} name
     * @returns 落選理由名称
     */
    reasonName(name: string) {
      return INSTANTWIN_LOSE_REASON[name]
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(
        createElement,
        column.label,
        Util.getSortClass(this.sortBy, column.sortBy),
        !!column.sortBy
      )
    },

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      if (!column.sortBy) {
        return
      }
      let sortBy = column.sortBy

      if (column.sortBy.indexOf('-') === 0) {
        if (this.sortBy === column.sortBy) {
          sortBy = column.sortBy.substring(1)
          this.$emit('sorting', { sortBy })
        } else {
          sortBy = column.sortBy
          this.$emit('sorting', { sortBy })
        }
      } else {
        if (this.sortBy === column.sortBy) {
          sortBy = '-' + column.sortBy
          this.$emit('sorting', { sortBy })
        } else {
          this.$emit('sorting', { sortBy })
        }
      }
    }
  }
})
</script>
